// utils.js
export const groupByAgentName = (data,module) => {
    console.log('data')
    console.log(data)
    let agent = ''
    let url = ''
    const grouped = data.reduce((acc, item) => {
        if (module === 'caps') {
            agent = item.c001_board_shortname;
            url = item.c001_board_url;
        }
        else {
            agent = item.e001_exam_agentshortname;
            url = item.e001_exam_url;
        }

        const key = `${agent}-${url}`;
        if (!acc[key]) {
            acc[key] = [];
        }
        acc[key].push(item);
        return acc;
        
    }, {});
    
    return grouped
};